import { render, staticRenderFns } from "./CertificateType.vue?vue&type=template&id=71223b3a&scoped=true"
import script from "./CertificateType.vue?vue&type=script&lang=ts"
export * from "./CertificateType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71223b3a",
  null
  
)

export default component.exports